import styled from "styled-components";

export const Container = styled.div`
  padding: 25px 0;
`;
